import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Utils } from '@app/_core/helper/Utils';
import { AppService } from '@app/_core/services/app.service';

@Component({
  selector: 'app-current-path',
  templateUrl: './current-path.component.html',
  styleUrls: ['./current-path.component.scss'],
})
export class CurrentPathComponent implements OnInit {
  @Input()
  currentPage!: string;
  currentpath: any = '';
  curPath = '';
  currentMenu: any = {};
  action = '';
  isDetailPage: boolean = false;
  isNewPage: boolean = false;
  clientAbbreviation: any;

  constructor(
    private appService: AppService,
    private router: Router
  ) {}

  ngOnInit() {
    this.clientAbbreviation = Utils.fetch('clientAbbreviation');
    this.appService.currentMenu.subscribe((val: boolean) => {
      this.currentMenu = val;
      console.log('this.currentMenu', this.currentMenu);

      if (this.router.url.toString().includes('Details')) {
        this.isDetailPage = true;
      }

      if (this.router.url.toString().includes('New')) {
        this.isNewPage = true;
      }
      /* let urlArray: any = this.router.url.split('/');
      urlArray.shift();
      if (urlArray.length > 0) {

        for (let i = 0; i < urlArray.length - 1; i++) {
          this.currentpath += urlArray[i] + (urlArray[i + 2] ? ">" : "");
        }
      }*/

      if (this.currentMenu) {
        if (this.currentMenu?.listmenu != '') {
         // console.log(this.currentMenu.listmenu);
          this.currentpath = this.currentMenu.listmenu.split('/')[1];
        }
        if (this.currentMenu?.menu != '') {
          this.currentpath = this.currentpath + ' <span class="arw"> > </span> ' + this.currentMenu.menu;
        }
        if (this.currentMenu?.listmenu == this.clientAbbreviation + '/Console' && !this.isDetailPage) {
          this.currentpath = this.currentpath + ' <span class="arw"> > </span> Manage ' + this.currentMenu.menu;
        } else if (this.currentMenu?.listmenu == this.clientAbbreviation + '/Console' && this.isDetailPage) {
          this.currentpath =
            this.currentpath +
            ' <span class="arw"> > </span> Manage  ' +
            this.currentMenu.menu +
            ' <span class="arw"> > </span> Details'; //this.currentMenu.menu +' Detail';
        }
        if (this.currentMenu?.listmenu == this.clientAbbreviation + '/Console' && this.isNewPage) {
          this.currentpath = this.currentpath + ' <span class="arw"> > </span> ' + 'New';
        }

        if (this.currentMenu?.submenu != '') {
          if(this.currentMenu?.submenu == 'LiveStatuses'){
            this.currentMenu.submenu = 'Live'+' '+'Statuses';
          }
          if(this.currentMenu?.submenu == 'HistoricalMetrics'){
            this.currentMenu.submenu = 'Historical'+' '+'Metrics';
          }

          if(this.currentMenu?.submenu == 'AIAudits'){
            this.currentMenu.submenu = 'AI Audits';
          }

          if(this.currentMenu?.submenu == 'AIInteractions'){
            this.currentMenu.submenu = 'AI Interactions';
          }

          this.currentpath = this.currentpath + ' <span class="arw"> > </span> ' + this.currentMenu.submenu;
        }

        this.action = this.currentMenu.name;
        // console.log('this.currentpath', this.currentpath);
        this.currentpath =
          this.currentpath.substring(0, this.currentpath.lastIndexOf('>') + 1) +
          '<strong>' +
          this.currentpath.substring(this.currentpath.lastIndexOf('>') + 1) +
          '</strong>';
        // console.log('this.currentpath', this.currentpath);
      }
    });
  }
}
